<template>
    <div
        class="app-header d-flex align-center"
        :class="
            display.smAndDown.value
                ? 'justify-space-between px-5 py-3'
                : 'pdx-60 py-3'
        "
    >
        <div>
            <a href="https://skolla.online/">
                <img :src="require('@/assets/images/logo.svg')" />
            </a>
        </div>

        <!-- Desktop Menu -->
        <div
            v-if="display.mdAndUp.value"
            class="d-flex align-center gap-5 ml-10"
        >
            <v-btn
                v-for="(menu, i) in menus"
                :key="i"
                :color="existingPathName === menu.name ? '#0e97d6' : '#020672'"
                variant="text"
                @click="$router.push(menu.path)"
            >
                <span class="font-weight-600 font-size-16">
                    {{ menu.text }}
                </span>
            </v-btn>
        </div>

        <!-- Mobile Menu Button -->
        <div v-if="display.smAndDown.value">
            <v-btn icon variant="text" @click="drawer = !drawer">
                <v-icon size="30">mdi-menu</v-icon>
            </v-btn>
        </div>

        <!-- Mobile Drawer -->
        <v-navigation-drawer
            v-model="drawer"
            location="right"
            temporary
            color="#0e97d6"
        >
            <div class="pa-4">
                <div class="text-h6 font-weight-bold mb-4">Menu</div>

                <v-list>
                    <v-list-item
                        v-for="(menu, i) in menus"
                        :key="i"
                        :active="existingPathName === menu.name"
                        @click="navigate(menu.path)"
                    >
                        <v-list-item-title>
                            {{ menu.text }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    inject: ['display'],
    data() {
        return {
            drawer: false,
            menus: [
                {
                    path: '/',
                    text: 'Paket Belajar',
                    name: 'Package',
                },
                {
                    path: '/cara-pembelian',
                    text: 'Cara Pembelian & Aktivasi',
                    name: 'HowToPurchase',
                },
            ],
        };
    },
    computed: {
        existingPathName() {
            return this.$route.name;
        },
    },
    methods: {
        navigate(path) {
            this.drawer = false;
            this.$router.push(path);
        },
    },
};
</script>

<style>
.app-header {
    position: fixed;
    z-index: 10 !important;
    width: 100%;
    background-color: #fff;
}
</style>
